import React, { useMemo } from "react";

// Types
import type { generalTab } from "src/types";

// Components
import { IcomDropdown } from "src/components/icom-dropdown";
import IcomThemeSwitcher from "src/components/icomThemeSwitcher";

interface GeneralProps {
  currentConfig: generalTab;
  setConfig: (config: any) => void;
  changeRegister: () => void;
}

const General: React.FC<GeneralProps> = ({ currentConfig, setConfig, changeRegister }) => {
  const handleRecordQuality = (option: { id: string; label: string; value: string }) => {
    changeRegister();
    setConfig({ recordQuality: option.value });
  };

  const recordQualityOptions = useMemo(
    () => [
      {
        id: "low",
        label: "Baixa",
        value: "low",
      },
      {
        id: "default",
        label: "Padrão",
        value: "default",
      },
    ],
    [],
  );

  return (
    <>
      <div className="max-w-[337px]">
        <div className="form-group flex flex-col gap-3 mb-10">
          <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">Qualidade da gravação</span>
          <IcomDropdown
            onChange={handleRecordQuality}
            selectedOption={currentConfig.recordQuality}
            listOptions={recordQualityOptions}
            className="text-neutral-gray-600! dark:text-neutral-gray-50"
          />
        </div>
      </div>

      {/* <div className="form-group flex flex-col gap-3 mb-10">
        <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">
          Habilitar logs Sentry?
        </span>
        <IcomSwitchBtn
          handleValue={handleSentryLogs}
          currentValue={currentConfig.sentryLogs}
          type="button"
        />
      </div> */}

      <div className="form-group flex flex-col gap-3">
        <IcomThemeSwitcher currentTheme={currentConfig.theme} setConfig={setConfig} changeRegister={changeRegister} />
      </div>
    </>
  );
};

export default General;
